/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Reminder
 */
export interface Reminder {
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    user_role: string;
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    author_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    author_role?: string;
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof Reminder
     */
    date: number;
    /**
     * 
     * @type {boolean}
     * @memberof Reminder
     */
    archived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    document_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Reminder
     */
    omit_reminder_text?: boolean;
}

/**
 * Check if a given object implements the Reminder interface.
 */
export function instanceOfReminder(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "user_role" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "date" in value;

    return isInstance;
}

export function ReminderFromJSON(json: any): Reminder {
    return ReminderFromJSONTyped(json, false);
}

export function ReminderFromJSONTyped(json: any, ignoreDiscriminator: boolean): Reminder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'user_id': json['user_id'],
        'user_role': json['user_role'],
        'author_id': !exists(json, 'author_id') ? undefined : json['author_id'],
        'author_role': !exists(json, 'author_role') ? undefined : json['author_role'],
        'message': json['message'],
        'date': json['date'],
        'archived': !exists(json, 'archived') ? undefined : json['archived'],
        'document_id': !exists(json, 'document_id') ? undefined : json['document_id'],
        'omit_reminder_text': !exists(json, 'omit_reminder_text') ? undefined : json['omit_reminder_text'],
    };
}

export function ReminderToJSON(value?: Reminder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user_id': value.user_id,
        'user_role': value.user_role,
        'author_id': value.author_id,
        'author_role': value.author_role,
        'message': value.message,
        'date': value.date,
        'archived': value.archived,
        'document_id': value.document_id,
        'omit_reminder_text': value.omit_reminder_text,
    };
}

